{
  "agb-form": {
    "text": {
      "accept": "Ich akzeptiere die ",
      "agb": "Allgemeine Geschäftsbedingungen"
    }
  }
}
